/**
 * PreferencesActions actions
 */

import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { rx } from '@shared/rx';
import { get } from 'lodash';
import { IAppState } from '../../reducers';
import { generateId } from '@shared/utils';
import { IAction, IDocumentOperationOptions } from '@app/shared/types';

@Injectable()
export class PreferencesActions {
  public static FETCH_PREFERENCES_FOR_COMPANY: string =
    'FETCH_PREFERENCES_FOR_COMPANY';
  public static FETCH_PREFERENCES_FOR_COMPANY_SUCCESS: string =
    'FETCH_PREFERENCES_FOR_COMPANY_SUCCESS';
  public static FETCH_PREFERENCES_FOR_COMPANY_ERROR: string =
    'FETCH_PREFERENCES_FOR_COMPANY_ERROR';

  public static ENTITY_TYPE: string = 'preferences';

  public ENTITY_TYPE: string = PreferencesActions.ENTITY_TYPE;

  /**
   * FETCH_PREFERENCES_FOR_COMPANY action creator.
   */
  public static fetchPreferencesForCompanyAction(
    query = null,
    options: IDocumentOperationOptions = {},
  ): IAction {
    return {
      type: PreferencesActions.FETCH_PREFERENCES_FOR_COMPANY,
      payload: { query, options } as any,
    };
  }

  /**
   * FETCH_PREFERENCES_FOR_COMPANY_SUCCESS action creator.
   */
  public static fetchPreferencesForCompanySuccessAction(
    response,
    options = {},
  ): IAction {
    return {
      type: PreferencesActions.FETCH_PREFERENCES_FOR_COMPANY_SUCCESS,
      payload: {
        response,
        options,
      },
    };
  }

  /**
   * FETCH_PREFERENCES_FOR_COMPANY_ERROR action creator.
   */
  public static fetchPreferencesForCompanyErrorAction(
    errors,
    options = {},
  ): IAction {
    return {
      type: PreferencesActions.FETCH_PREFERENCES_FOR_COMPANY_ERROR,
      payload: {
        errors,
        options,
      },
    };
  }

  public constructor(private ngRedux: NgRedux<IAppState>) {}

  public resultAsPromised(requestId): Promise<any> {
    const selectionPath: string[] = [PreferencesActions.ENTITY_TYPE];

    return this.ngRedux
      .select(selectionPath.concat('operationResult'))
      .pipe(
        rx.find(
          (result: any) => get(result, 'options.requestId') === requestId,
        ),
      )
      .toPromise()
      .then((operationResult: any): any => {
        if (!operationResult.response) {
          return new Error('operationResult.response is not valid');
        }

        return operationResult.response;
      });
  }

  public fetchPreferencesForCompany(
    query = null,
    options: IDocumentOperationOptions = {},
  ): Promise<any> {
    const reqOptions: any = Object.assign({ requestId: generateId() }, options);
    this.ngRedux.dispatch(
      PreferencesActions.fetchPreferencesForCompanyAction(query, reqOptions),
    );

    return this.resultAsPromised(reqOptions.requestId);
  }
}
